import { CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { useQsFilters } from "../../hooks/filters"
import { TableTexts } from "./TableTexts"
import { useTextsList } from "../../hooks/texts"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
  } as FiltersBase)

export default function Texts() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useTextsList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  useBreadcrumbs([{ label: "Testi" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Testi</H1>
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value, page: 1 })
            }}
          />
        </Flex>
        <TableTexts
          texts={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
